import React, { useState } from 'react'
import { Button, Card, Modal, Space, Table, Tooltip } from 'antd'
import {
    EyeOutlined,
    DeleteOutlined,
    CloudDownloadOutlined,
} from '@ant-design/icons'
import commontStyles from './document.less'

import { ErrorMessage } from '../../../../../../Utils/Notification'
import PDFPreview from '../../../../../../Components/PDFPreview'
import {
    createPreSignedUrl,
    deleteFileFromServer,
    downloadFileFromServer,
} from '../../../../../../Services/s3upload'

const DocumentViewModelForm = (props: {
    data: string
    itshow: number
    afterDeleteCallBack: () => void
}): React.ReactElement => {
    const { data, itshow, afterDeleteCallBack } = props
    const [imagePath, setImagePath] = useState('')
    const [visible, setVisible] = useState(false)
    const [previewPdf, setPdfPreview] = useState(false)
    const [pdfURL, setUrl] = useState('')
    const [buttonLoading, setButtonLoading] = useState(false)
    const Servicecolumns = [
        {
            title: 'File',
            dataIndex: 'attachmentPath',
            key: 'key',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_: any, record: any) => {
                return (
                    <Space size="middle">
                        <Space size="middle">
                            {itshow === 0 ? (
                                <>
                                    <Tooltip title="View">
                                        <EyeOutlined
                                            onClick={() => {
                                                handleViewImage(record.key)
                                            }}
                                        />
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                        <Button
                                            icon={<DeleteOutlined />}
                                            onClick={() => {
                                                void handleDeleteClick(
                                                    record.attachmentPath
                                                )
                                                setButtonLoading(true)
                                            }}
                                            loading={buttonLoading}
                                        />
                                    </Tooltip>
                                </>
                            ) : (
                                <Tooltip title="Download Document">
                                    <CloudDownloadOutlined
                                        onClick={() => {
                                            downloadDocument(record.key)
                                        }}
                                    />
                                </Tooltip>
                            )}
                        </Space>
                    </Space>
                )
            },
        },
    ]
    const downloadDocument = (fileurl: string): void => {
        void downloadFileFromServer(fileurl)
    }
    const getFileExtension = (url: string | undefined): string | undefined => {
        if (url != null) {
            return url.split('.').pop()?.toLowerCase()
        }
        return undefined
    }
    const handleViewImage = (imagePath: string): void => {
        void handleViewDocument(imagePath)
    }
    const handleViewDocument = async (imagePath: string): Promise<void> => {
        const preSignedUrl = await createPreSignedUrl(imagePath)
        if (preSignedUrl !== null) {
            const fileExtension = getFileExtension(imagePath)
            if (fileExtension === 'pdf') {
                setUrl(preSignedUrl)
                setPdfPreview(true)
                setVisible(false)
            } else {
                setImagePath(preSignedUrl)
                setVisible(true)
            }
        }
    }

    const handleDeleteClick = async (filePath: string): Promise<void> => {
        try {
            await deleteFileFromServer(filePath)
            if (afterDeleteCallBack !== undefined) {
                afterDeleteCallBack()
            }
            setButtonLoading(false)
        } catch (error) {
            ErrorMessage('Error deleting S3 object:')
        }
    }

    const changeCreateEditModalStatus = (): void => {
        setPdfPreview(false)
    }

    //     <Table
    //     columns={Servicecolumns}
    //     dataSource={fileList?.map((file) => ({
    //         key: file,
    //         attachmentPath: file.substring(
    //             file.lastIndexOf('/') + 1
    //         ),
    //     }))}
    //     pagination={false}
    // />
    return (
        <div>
            <Card>
                <Table
                    columns={Servicecolumns}
                    dataSource={[
                        {
                            key: data,
                            attachmentPath: data.substring(
                                data.lastIndexOf('/') + 1
                            ),
                        },
                    ]}
                    pagination={false}
                />
            </Card>
            <Modal
                width={'60%'}
                open={visible}
                onCancel={() => {
                    setVisible(false)
                }}
                footer={null}
            >
                <img
                    src={imagePath}
                    alt="View"
                    className={commontStyles.imagewidth}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changeCreateEditModalStatus}
                width={'50%'}
                title={''}
                open={previewPdf}
            >
                <PDFPreview pdfUrl={pdfURL} />
            </Modal>
        </div>
    )
}

export default DocumentViewModelForm
